import React from 'react';
import {Box, Typography} from '@mui/material';

/**
 * Horizontal metadata bar showing contextual report info (country, date, source, etc.)
 *
 * Props:
 *   items  {Array<{label, value}>}  – metadata items to display
 */
const MetaInfoBar = ({items = []}) => (
    <Box sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: {xs: 2, md: 0},
        border: '1px solid var(--brand-border, #E5E7EB)',
        borderRadius: '12px',
        backgroundColor: 'var(--brand-surface, #ffffff)',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        mb: 3,
        overflow: 'hidden',
    }}>
        {items.map((item, idx) => (
            <Box key={item.label} sx={{
                flex: {xs: '1 1 40%', md: 1},
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                px: 2.5,
                py: 2,
                borderRight: {md: idx < items.length - 1 ? '1px solid #E5E7EB' : 'none'},
            }}>
                <Box>
                    <Typography sx={{
                        fontSize: '10px',
                        fontWeight: 700,
                        color: '#9CA3AF',
                        letterSpacing: '0.8px',
                        textTransform: 'uppercase',
                        mb: 0.2,
                    }}>
                        {item.label}
                    </Typography>
                    <Typography sx={{
                        fontSize: '13px',
                        fontWeight: 600,
                        color: '#111827',
                    }}>
                        {item.value}
                    </Typography>
                </Box>
            </Box>
        ))}
    </Box>
);

export default MetaInfoBar;
